<template>
    <div class="row mt-2">
        <div class="col-12">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li v-if="myShop" class="breadcrumb-item">
                        <router-link :to="{ name: 'dashboard' }">
                            <i class="fas fa-store"></i> {{myShop.shopName}}
                        </router-link>
                    </li>
                    <li v-else class="breadcrumb-item">
                        <router-link :to="{ name: 'dashboard' }">Shop</router-link>
                    </li>
                    <template v-if="subTitle">
                        <li class="breadcrumb-item">
                            <span class="hide-on-mobile">
                                <router-link :to="{ name: pageTitleUrl ? pageTitleUrl.toLowerCase() : pageTitle.toLowerCase() }">{{pageTitle | capitalize}}</router-link>
                            </span>
                        </li>
                        <li class="breadcrumb-item active text-capitalize hide-on-mobile" aria-current="page">{{subTitle}}</li>
                    </template>
                    <template v-else>
                        <li class="breadcrumb-item active text-capitalize hide-on-mobile" aria-current="page">{{pageTitle}}</li>
                    </template>
                </ol>
            </nav>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { webpageTitle } from '@/store/dry'

export default {
    name: "Breadcrumb",
    props: ['pageTitle', 'pageTitleUrl', 'subTitle'],
    computed: {
        ...mapGetters(['user', 'userShop']),
        myShop() {
            if(this.user && this.userShop && this.userShop !== null){
                webpageTitle(`${this.userShop.shopName} (@${this.user.userHandle}) Shop+`)
                return this.userShop
            }
            return false
        },
    }
}
</script>